import React from 'react';

const AsyncClientList = React.lazy(() => import('./ListContainer'));

export const ClientList = () => {
  return <AsyncClientList />;
};
